import { Box, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

import { Text } from "../../components/Text";
import { getSystemEventDisplay } from "../utils/customMessageDisplay";

export interface ChatSystemMessageProps {
  /**
   * The Sendbird custom type string
   */
  customType: string;
  /**
   * The raw message content (may be JSON with facility/agent text)
   */
  message: string;
  /**
   * Optional additional styles
   */
  sx?: SxProps<Theme>;
}

/**
 * Renders system event messages (shift bookings, check-ins, cancellations, etc.)
 * as centered, muted inline text.
 */
export function ChatSystemMessage(props: ChatSystemMessageProps) {
  const { customType, message, sx } = props;
  const { displayText } = getSystemEventDisplay(customType, message);

  return (
    <Box
      sx={mergeSxProps(
        {
          display: "flex",
          justifyContent: "center",
          paddingY: 2,
          paddingX: 4,
        },
        sx
      )}
    >
      <Text
        sx={(theme) => ({ color: theme.palette.base?.muted, textAlign: "center" })}
        variant="caption"
      >
        {displayText}
      </Text>
    </Box>
  );
}
